export default "__VITE_ASSET__C$USMzMu__"